<script lang="ts">
    import type {Conversation} from './types';
    import {assertValued, createAutoUpdatingStore, getElapsedTime, wasStarted} from './service/util';

    export let conversation: Conversation;

    function getConversationElapsedTime() {
        if (!wasStarted(conversation)) {
            return null;
        }
        return getElapsedTime(assertValued(conversation.startDate), conversation.endDate || new Date());
    }

    const elapsedTime = createAutoUpdatingStore(() => getConversationElapsedTime(), 1000);
</script>

{#if $elapsedTime}
	<span style="font-weight: bold;">
		{$elapsedTime}
	</span>
{/if}